import { defineStore } from "pinia";

export const useSystemStore = defineStore("system", () => {
  const isGlobalLoading = ref(false);
  const loadingMessage = ref("Processing...");
  const startTime = ref(0);
  const MIN_DISPLAY_TIME = 850;

  function startLoading(message = "Processing...") {
    loadingMessage.value = message;
    isGlobalLoading.value = true;
    startTime.value = Date.now();
  }

  async function stopLoading() {
    const elapsed = Date.now() - startTime.value;
    const remaining = MIN_DISPLAY_TIME - elapsed;

    if (remaining > 0) {
      // Wait for the remainder of the minimum time
      await new Promise((resolve) => setTimeout(resolve, remaining));
    }

    isGlobalLoading.value = false;
  }

  return { isGlobalLoading, loadingMessage, startLoading, stopLoading };
});
